import { createApp } from 'vue'
import App from './App.vue'

import ArcoVue from '@arco-design/web-vue';
import '@arco-design/web-vue/dist/arco.css';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';

import router from "./utils/router.js";
import functions from './utils/functions.js';
import { createPinia } from 'pinia';
import WujieVue from 'wujie-vue3';

const app = createApp(App)

// 无界
// 不适合非vue\react的框架，因为子应用的链接会跳转出主应用
// 参考 https://wujie-micro.github.io/doc/guide/start.html
app.use(WujieVue)
// 注入全局变量，模板中可直接使用
app.config.globalProperties.$fn = functions
// 使用路由
app.use(router)
// 使用状态管理器
const pinia = createPinia();
app.use(pinia)
// arco
app.use(ArcoVue);
app.use(ArcoVueIcon);

app.mount('#app')
